(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-actifs-formule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mon-actifs-formule')) {
    customElements.define(
      'mon-actifs-formule',
      class MonActifsFormule extends HTMLElement {
        connectedCallback() {
          this.videos = [...this.querySelectorAll('video')];
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mobileViewport = window.matchMedia('(max-width: 749px)');
          this.isVisible = false;

          if (!this.videos.length || this.reducedMotion.matches) return;

          this.videos.forEach((video) => {
            video.muted = true;
          });

          this.syncPlayback = () => {
            const activeVideo = this.videos.find((video) => window.getComputedStyle(video).display !== 'none');

            this.videos.forEach((video) => {
              if (video !== activeVideo) video.pause();
            });

            if (activeVideo && this.isVisible && !document.hidden) {
              activeVideo.play().catch(() => {});
            } else {
              activeVideo?.pause();
            }
          };

          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.isVisible = entry.isIntersecting;
              this.syncPlayback();
            },
            { threshold: 0.2 }
          );

          this.visibilityHandler = () => this.syncPlayback();
          this.viewportHandler = () => this.syncPlayback();

          this.observer.observe(this);
          document.addEventListener('visibilitychange', this.visibilityHandler);
          this.mobileViewport.addEventListener('change', this.viewportHandler);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          document.removeEventListener('visibilitychange', this.visibilityHandler);
          this.mobileViewport?.removeEventListener('change', this.viewportHandler);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-besoins-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mon-needs-editorial')) {
    customElements.define('mon-needs-editorial', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-need-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-need-panel]'));
        this.previous = this.querySelector('[data-need-prev]');
        this.next = this.querySelector('[data-need-next]');
        this.status = this.querySelector('[data-need-status]');
        this.index = 0;
        this.touchStart = null;
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.activate(index, true)));
        this.previous?.addEventListener('click', () => this.activate(this.index - 1, true));
        this.next?.addEventListener('click', () => this.activate(this.index + 1, true));
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.activate(this.index - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.activate(this.index + 1, true); }
        });
        this.addEventListener('touchstart', event => { this.touchStart = event.touches[0].clientX; }, { passive:true });
        this.addEventListener('touchend', event => {
          if (this.touchStart === null) return;
          const delta = event.changedTouches[0].clientX - this.touchStart;
          if (Math.abs(delta) > 55) this.activate(this.index + (delta < 0 ? 1 : -1), false);
          this.touchStart = null;
        }, { passive:true });
        this.activate(0, false);
      }
      hydrate(panel) {
        panel.querySelectorAll('img[data-src]').forEach(image => { image.src = image.dataset.src; image.removeAttribute('data-src'); });
      }
      activate(index, focus) {
        if (!this.tabs.length) return;
        this.index = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, position) => {
          const active = position === this.index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, position) => {
          const active = position === this.index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active) this.hydrate(panel);
        });
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.tabs.length - 1;
        this.status.textContent = `${this.tabs[this.index].textContent.trim()}, ${this.index + 1} sur ${this.tabs.length}`;
        if (focus) this.tabs[this.index].focus({ preventScroll:true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-besoins"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '[data-mon-besoins]';
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    const setup = (section) => {
      if (!section || section.dataset.monBesoinsReady === 'true') return;

      const scroller = section.querySelector('[data-mon-besoins-scroller]');
      const prevBtn = section.querySelector('[data-mon-besoins-prev]');
      const nextBtn = section.querySelector('[data-mon-besoins-next]');
      const originals = Array.prototype.slice.call(
        section.querySelectorAll('[data-mon-besoins-card]:not([data-mon-besoins-clone])')
      );
      if (!scroller || !originals.length) return;

      section.dataset.monBesoinsReady = 'true';

      const speed = Math.max(0, parseFloat(section.dataset.monBesoinsSpeed) || 0);
      const dirSign = section.dataset.monBesoinsDirection === 'left' ? 1 : -1;
      const pauseOnHover = section.dataset.monBesoinsPauseHover !== 'false';
      const looping = speed > 0 && originals.length > 1 && !reduceMotionQuery.matches;

      let loopWidth = 0;
      let offset = 0;
      let lastApplied = 0;
      let rafId = null;
      let lastTs = 0;
      let tween = null;
      let hovering = false;
      let focused = false;
      let dragging = false;
      let interacting = false;
      let offscreen = false;
      let interactTimer = null;
      let resizeTimer = null;

      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let dragPointerId = null;

      const getStep = () => {
        const card = originals[0];
        if (!card) return 260;
        const styles = window.getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const isPaused = () =>
        hovering || focused || dragging || interacting || offscreen || document.hidden;

      const wrap = (value) => {
        if (!loopWidth) return value;
        let next = value % loopWidth;
        if (next < 0) next += loopWidth;
        return next;
      };

      const apply = (value) => {
        offset = value;
        scroller.scrollLeft = offset;
        lastApplied = scroller.scrollLeft;
      };

      const measure = () => {
        loopWidth = getStep() * originals.length;
      };

      const ensureClones = () => {
        if (!loopWidth) return;
        const existing = section.querySelectorAll('[data-mon-besoins-clone]').length;
        const needed = Math.max(2, Math.ceil(scroller.clientWidth / loopWidth) + 1);
        let sets = 1 + Math.round(existing / originals.length);

        while (sets < needed) {
          const fragment = document.createDocumentFragment();
          originals.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.setAttribute('data-mon-besoins-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('id');
            Array.prototype.slice.call(clone.attributes).forEach((attr) => {
              if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
            });
            clone.querySelectorAll('a, button, input').forEach((el) => {
              el.setAttribute('tabindex', '-1');
            });
            fragment.appendChild(clone);
          });
          scroller.appendChild(fragment);
          sets += 1;
        }
      };

      const pauseFor = (delay) => {
        interacting = true;
        window.clearTimeout(interactTimer);
        interactTimer = window.setTimeout(() => {
          interacting = false;
          if (looping) apply(wrap(scroller.scrollLeft));
        }, delay || 2000);
      };

      const frame = (ts) => {
        rafId = window.requestAnimationFrame(frame);
        if (!lastTs) lastTs = ts;
        const dt = Math.min((ts - lastTs) / 1000, 0.05);
        lastTs = ts;

        if (tween) {
          const progress = Math.min((ts - tween.start) / tween.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          apply(wrap(tween.from + (tween.to - tween.from) * eased));
          if (progress >= 1) tween = null;
          return;
        }

        if (isPaused()) return;
        apply(wrap(offset + dirSign * speed * dt));
      };

      const startLoop = () => {
        if (!looping || rafId !== null) return;
        lastTs = 0;
        rafId = window.requestAnimationFrame(frame);
      };

      const stopLoop = () => {
        if (rafId === null) return;
        window.cancelAnimationFrame(rafId);
        rafId = null;
      };

      const updateArrows = () => {
        if (!prevBtn || !nextBtn) return;
        if (looping) {
          prevBtn.disabled = false;
          nextBtn.disabled = false;
          return;
        }
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        prevBtn.disabled = scroller.scrollLeft <= 2;
        nextBtn.disabled = scroller.scrollLeft >= maxScroll - 2;
      };

      const advance = (direction) => {
        if (!looping) {
          scroller.scrollBy({
            left: getStep() * direction,
            behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
          });
          return;
        }
        tween = {
          from: offset,
          to: offset + getStep() * direction,
          start: window.performance.now(),
          duration: 480,
        };
        pauseFor(2400);
      };

      prevBtn?.addEventListener('click', () => advance(-1));
      nextBtn?.addEventListener('click', () => advance(1));

      const onScroll = () => {
        if (!looping) {
          window.requestAnimationFrame(updateArrows);
          return;
        }
        if (dragging || tween) return;
        if (Math.abs(scroller.scrollLeft - lastApplied) <= 2) return;
        offset = scroller.scrollLeft;
        lastApplied = offset;
        pauseFor(2400);
      };

      scroller.addEventListener('scroll', onScroll, { passive: true });

      scroller.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          advance(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          advance(1);
        }
        if (!looping && event.key === 'Home') {
          event.preventDefault();
          scroller.scrollTo({ left: 0, behavior: reduceMotionQuery.matches ? 'auto' : 'smooth' });
        }
        if (!looping && event.key === 'End') {
          event.preventDefault();
          scroller.scrollTo({
            left: scroller.scrollWidth,
            behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
          });
        }
      });

      const onPointerDown = (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        dragging = true;
        moved = false;
        tween = null;
        startX = event.clientX;
        startScroll = looping ? offset : scroller.scrollLeft;
        dragPointerId = event.pointerId;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture?.(event.pointerId);
      };

      const onPointerMove = (event) => {
        if (!dragging) return;
        if (dragPointerId !== null && event.pointerId !== dragPointerId) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) moved = true;
        if (looping) {
          apply(wrap(startScroll - delta));
        } else {
          scroller.scrollLeft = startScroll - delta;
        }
      };

      const endDrag = (event) => {
        if (!dragging) return;
        if (dragPointerId !== null && event.pointerId !== dragPointerId) return;
        dragging = false;
        scroller.classList.remove('is-dragging');
        if (scroller.hasPointerCapture?.(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }
        dragPointerId = null;
        if (looping) pauseFor(1600);
        updateArrows();
      };

      scroller.addEventListener('pointerdown', onPointerDown);
      scroller.addEventListener('pointermove', onPointerMove);
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);

      scroller.addEventListener('click', (event) => {
        if (!moved) return;
        const link = event.target.closest('a');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      scroller.addEventListener('mouseenter', () => {
        if (pauseOnHover && hoverQuery.matches) hovering = true;
      });
      scroller.addEventListener('mouseleave', () => {
        hovering = false;
      });
      scroller.addEventListener('focusin', () => {
        focused = true;
      });
      scroller.addEventListener('focusout', () => {
        focused = false;
      });

      const relayout = () => {
        measure();
        if (looping) {
          ensureClones();
          apply(wrap(offset));
        }
        updateArrows();
      };

      const onResize = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(relayout, 150);
      };

      const onVisibility = () => {
        if (!document.hidden) lastTs = 0;
      };

      const onBlockSelect = (event) => {
        if (!section.contains(event.target)) return;
        pauseFor(10000);
        event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };

      window.addEventListener('resize', onResize, { passive: true });
      document.addEventListener('visibilitychange', onVisibility);
      document.addEventListener('shopify:block:select', onBlockSelect);

      let observer = null;
      if (looping && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              offscreen = !entry.isIntersecting;
            });
          },
          { rootMargin: '160px 0px' }
        );
        observer.observe(section);
      }

      section.monBesoinsDestroy = () => {
        stopLoop();
        window.clearTimeout(interactTimer);
        window.clearTimeout(resizeTimer);
        window.removeEventListener('resize', onResize);
        document.removeEventListener('visibilitychange', onVisibility);
        document.removeEventListener('shopify:block:select', onBlockSelect);
        observer?.disconnect();
        section.querySelectorAll('[data-mon-besoins-clone]').forEach((node) => node.remove());
        scroller.classList.remove('is-loop');
        delete section.dataset.monBesoinsReady;
      };

      measure();
      if (looping) {
        scroller.classList.add('is-loop');
        ensureClones();
        apply(0);
        startLoop();
      }
      updateArrows();
    };

    const initAll = (root) => {
      const scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches(SECTION_SELECTOR)) setup(scope);
      scope.querySelectorAll(SECTION_SELECTOR).forEach(setup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!target || !target.querySelectorAll) return;
      const nodes = target.matches && target.matches(SECTION_SELECTOR)
        ? [target]
        : Array.prototype.slice.call(target.querySelectorAll(SECTION_SELECTOR));
      nodes.forEach((node) => node.monBesoinsDestroy?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-bubble-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (!root || root.dataset.monBubbleReady === 'true') return;
      root.dataset.monBubbleReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-mon-bubble-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-mon-bubble-dot]'));
      const previous = root.querySelector('[data-mon-bubble-previous]');
      const next = root.querySelector('[data-mon-bubble-next]');
      const stage = root.querySelector('[data-mon-bubble-stage]');
      const status = root.querySelector('[data-mon-bubble-status]');

      if (slides.length < 2) return;

      let current = 0;
      let touchStartX = 0;
      let touchStartY = 0;

      function show(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (status) status.textContent = `${current + 1} / ${slides.length}`;
      }

      previous?.addEventListener('click', () => show(current - 1));
      next?.addEventListener('click', () => show(current + 1));

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => show(dotIndex));
      });

      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(current - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + 1);
        }
      });

      stage?.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
          touchStartY = event.changedTouches[0].clientY;
        },
        { passive: true }
      );

      stage?.addEventListener(
        'touchend',
        (event) => {
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          const deltaY = event.changedTouches[0].clientY - touchStartY;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          show(deltaX > 0 ? current - 1 : current + 1);
        },
        { passive: true }
      );

      document.addEventListener('shopify:block:select', (event) => {
        const selected = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (!selected) return;
        const selectedIndex = Number(selected.dataset.slideIndex);
        if (Number.isNaN(selectedIndex)) return;
        show(selectedIndex);
      });

      show(0);
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-mon-bubble-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-catalogue"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.catReady === '1') return;
      root.dataset.catReady = '1';

      var none    = root.querySelector('[data-cat-none]');
      var countEl = root.querySelector('[data-cat-count]');
      var chipsEl = root.querySelector('[data-cat-chips]');
      var clearEl = root.querySelector('[data-cat-clear]');
      var sortSel = root.querySelector('[data-cat-sort]');
      var toggle  = root.querySelector('[data-cat-toggle]');
      var panel   = root.querySelector('[data-cat-filters]');
      var badge   = root.querySelector('[data-cat-active-count]');
      var boxes   = Array.prototype.slice.call(root.querySelectorAll('.mon-cat__box'));
      var gammes  = Array.prototype.slice.call(root.querySelectorAll('[data-cat-gamme]'));
      if (!gammes.length) return;

      // Les cartes sont réparties dans plusieurs grilles : on garde
      // l'ordre d'origine par grille pour pouvoir y revenir.
      gammes.forEach(function (g) {
        var grid = g.querySelector('.mon-cat__grid');
        if (!grid) return;
        Array.prototype.slice.call(grid.children).forEach(function (c, i) {
          c.dataset.order = String(i);
        });
      });

      function selected() {
        var groups = {};
        boxes.forEach(function (b) {
          if (!b.checked) return;
          (groups[b.dataset.group] = groups[b.dataset.group] || []).push(b.value);
        });
        return groups;
      }

      function labelOf(box) {
        var el = box.parentElement.querySelector('.mon-cat__opt-label');
        return el ? el.textContent.trim() : box.value;
      }

      function apply() {
        var groups = selected();
        var keys = Object.keys(groups);
        var total = 0;

        gammes.forEach(function (g) {
          var cards = Array.prototype.slice.call(g.querySelectorAll('.mon-cat__card'));
          var emptyMsg = g.querySelector('[data-cat-gamme-empty]');
          var shown = 0;

          cards.forEach(function (card) {
            var tags = card.dataset.tags || '';
            // ET entre les familles, OU à l'intérieur d'une famille.
            var ok = keys.every(function (k) {
              return groups[k].some(function (v) { return tags.indexOf('~' + v + '~') > -1; });
            });
            card.hidden = !ok;
            if (ok) shown += 1;
          });

          total += shown;

          if (cards.length) {
            // Une gamme sans résultat disparaît plutôt que d'afficher un vide.
            g.hidden = shown === 0 && keys.length > 0;
            if (emptyMsg) emptyMsg.hidden = true;
          } else {
            // Gamme annoncée sans produit : on la masque dès qu'un filtre est posé.
            g.hidden = keys.length > 0;
          }
        });

        if (countEl) countEl.textContent = String(total);
        if (none) none.hidden = total !== 0;

        var active = boxes.filter(function (b) { return b.checked; });
        if (clearEl) clearEl.hidden = active.length === 0;
        if (badge) {
          badge.hidden = active.length === 0;
          badge.textContent = String(active.length);
        }

        if (chipsEl) {
          chipsEl.innerHTML = '';
          chipsEl.hidden = active.length === 0;
          active.forEach(function (b) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'mon-cat__chip';
            chip.appendChild(document.createTextNode(labelOf(b)));
            var x = document.createElement('span');
            x.setAttribute('aria-hidden', 'true');
            x.textContent = '×';
            chip.appendChild(x);
            chip.setAttribute('aria-label', 'Retirer le filtre ' + labelOf(b));
            chip.addEventListener('click', function () { b.checked = false; apply(); });
            chipsEl.appendChild(chip);
          });
        }
      }

      function sortBy(mode) {
        gammes.forEach(function (g) {
          var grid = g.querySelector('.mon-cat__grid');
          if (!grid) return;
          var cards = Array.prototype.slice.call(grid.children);
          if (mode === 'price-asc') {
            cards.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
          } else if (mode === 'price-desc') {
            cards.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
          } else if (mode === 'title') {
            cards.sort(function (a, b) {
              return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'fr');
            });
          } else {
            cards.sort(function (a, b) { return (+a.dataset.order) - (+b.dataset.order); });
          }
          cards.forEach(function (c) { grid.appendChild(c); });
        });
      }

      boxes.forEach(function (b) { b.addEventListener('change', apply); });

      if (clearEl) {
        clearEl.addEventListener('click', function () {
          boxes.forEach(function (b) { b.checked = false; });
          apply();
        });
      }

      if (sortSel) {
        sortSel.addEventListener('change', function () { sortBy(sortSel.value); apply(); });
      }

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      apply();
    }

    function boot() { document.querySelectorAll('[data-mon-cat]').forEach(init); }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-diagnostic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Les trois gammes (12 octobre 2026). Chaque gamme : le soin
    // essentiel, son complément, le soin du regard par défaut, et la
    // phrase qui explique le choix en tête du résultat.
    var GAMMES = {
      sublime: {
        nom: 'Sublime-Âge',
        soins: ['serum', 'creme_sa'],
        regard: 'regard_sa',
        texte: "Pour des rides installées et un visage qui perd en rebond : peptides et acide hyaluronique, pour une peau qui paraît plus lisse et plus souple."
      },
      hydratation: {
        nom: 'Hydratation',
        soins: ['gel', 'creme_hydra'],
        regard: 'regard_hydra',
        texte: "Pour une peau qui manque d'eau : des textures qui l'attirent et la retiennent, pour que les ridules de déshydratation se voient moins."
      },
      nourrissante: {
        nom: 'Nourrissante',
        soins: ['creme_nourr', 'huile'],
        regard: 'regard_sa',
        texte: "Pour une peau sèche et rêche : des textures qui nourrissent et adoucissent, pour un toucher plus souple et un teint plus lumineux."
      }
    };

    var STEP_LABEL = {
      nettoyer: 'Nettoyer',
      traiter: 'Traiter',
      regard: 'Contour des yeux',
      hydrater: 'Hydrater',
      nourrir: 'Nourrir'
    };

    var STEP_ORDER = ['nettoyer', 'traiter', 'regard', 'hydrater', 'nourrir'];

    var MOMENT_LABEL = { matin: 'Matin', soir: 'Soir', les_deux: 'Matin et soir' };

    // Une phrase par question. Courte, concrète, sans jargon.
    var WHY = {
      signe: "On part de ce que vous voyez. C'est ce qui choisit votre gamme.",
      yeux: "La peau du contour est plus fine que le reste du visage : elle a son propre soin.",
      ressenti: "C'est ce qui décide de la texture : un gel qui hydrate, ou une crème qui nourrit.",
      nettoyage: "Un nettoyant trop fort fait perdre à la peau l'eau que les soins lui apportent."
    };

    function first(list, test) {
      for (var i = 0; i < list.length; i += 1) if (test(list[i])) return list[i];
      return null;
    }

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function init(root) {
      if (root.dataset.diagReady === '1') return;
      root.dataset.diagReady = '1';

      var panels = {};
      root.querySelectorAll('[data-panel]').forEach(function (el) { panels[el.dataset.panel] = el; });

      var allQuestions = Array.prototype.slice.call(root.querySelectorAll('.mon-diag__q'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('.mon-diag__card'));
      var coffrets = Array.prototype.slice.call(root.querySelectorAll('[data-diag-coffret]'));
      var pool = root.querySelector('[data-diag-pool]');
      var listEl = root.querySelector('[data-diag-list]');
      var progress = root.querySelector('[data-diag-progress]');
      var backBtns = Array.prototype.slice.call(root.querySelectorAll('[data-diag-back]'));
      var nextBtn = root.querySelector('[data-diag-next]');
      var requiredEl = root.querySelector('[data-diag-required]');
      var whyWrap = root.querySelector('[data-diag-why]');
      var whyBody = root.querySelector('[data-diag-why-body]');
      var noteEl = root.querySelector('[data-diag-note]');
      var resultTitle = root.querySelector('[data-diag-result-title]');
      var resultLede = root.querySelector('[data-diag-result-lede]');
      var laterEl = root.querySelector('[data-diag-later]');
      var laterList = root.querySelector('[data-diag-later-list]');
      var cautionsEl = root.querySelector('[data-diag-cautions]');
      var cautionsList = root.querySelector('[data-diag-cautions-list]');
      var buyEl = root.querySelector('[data-diag-buy]');
      var buyBtn = root.querySelector('[data-diag-add]');
      var totalEl = root.querySelector('[data-diag-total]');
      var buyNote = root.querySelector('[data-diag-buy-note]');
      var offerEl = root.querySelector('[data-diag-offer]');
      var emailForm = root.querySelector('.mon-diag__form');
      var emailInput = root.querySelector('[data-diag-email]');
      var emailError = root.querySelector('[data-diag-email-error]');
      var tagsInput = root.querySelector('[data-diag-tags]');
      var thanksEl = root.querySelector('[data-diag-thanks]');
      var keepText = root.querySelector('[data-diag-keep-text]');
      var mediaImg = root.querySelector('[data-diag-media-img]');
      var mediaBox = root.querySelector('[data-diag-media]');
      var introImage = root.dataset.imgIntro || '';

      // La pile de portraits. Mélangée à l'ouverture : deux visiteurs
      // ne voient pas la même succession de visages, et celui qui
      // refait le diagnostic ne revoit pas le même défilé.
      var deck = (root.dataset.photos || '').split('|').filter(Boolean);
      function shuffle() {
        for (var i = deck.length - 1; i > 0; i -= 1) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = deck[i]; deck[i] = deck[j]; deck[j] = t;
        }
      }
      shuffle();

      // Une photo toutes les N questions : changer à chaque écran
      // donne un diaporama, pas un entretien.
      var photoEvery = Math.max(1, parseInt(root.dataset.photoEvery, 10) || 2);

      // Les portraits sont servis par le CDN Shopify en 2160 px de large.
      // On lui demande la taille réellement affichée, densité d'écran
      // comprise : un écran Retina reçoit du net, un téléphone ne
      // télécharge pas 2 Mo pour un bandeau de 375 px. Les URL d'asset
      // du thème n'acceptent pas ce paramètre — on les laisse telles quelles.
      var PALIERS = [600, 900, 1200, 1600, 2000, 2400];

      // Le volet mesure 0 tant que le dialogue est fermé : on estime
      // alors sa largeur d'après --mon-diag-media (pleine largeur sous
      // 990 px, où il devient un bandeau).
      function boxWidth() {
        if (mediaBox && mediaBox.clientWidth) return mediaBox.clientWidth;
        var vw = window.innerWidth || 1200;
        if (vw <= 989) return vw;
        var part = parseFloat(window.getComputedStyle(root).getPropertyValue('--mon-diag-media')) || 40;
        return Math.round(vw * part / 100);
      }

      function sized(url) {
        if (!url || url.indexOf('width=') === -1) return url;
        var besoin = Math.ceil(boxWidth() * Math.min(window.devicePixelRatio || 1, 2));
        var w = PALIERS[PALIERS.length - 1];
        for (var i = 0; i < PALIERS.length; i += 1) {
          if (PALIERS[i] >= besoin) { w = PALIERS[i]; break; }
        }
        return url.replace(/([?&])width=\d+/, '$1width=' + w);
      }

      // Fondu enchaîné sur deux calques : on ne découvre jamais le fond.
      var layers = [mediaImg, root.querySelector('[data-diag-media-img-b]')].filter(Boolean);
      var front = 0;

      function swapTo(raw) {
        var src = sized(raw);
        if (!src || layers.length < 2) return;
        var out = layers[front];
        if (out.getAttribute('src') === src) return;
        var incoming = layers[1 - front];
        var reveal = function () {
          incoming.classList.add('is-on');
          out.classList.remove('is-on');
          front = 1 - front;
        };
        if (incoming.getAttribute('src') === src && incoming.complete) return reveal();
        incoming.onload = reveal;
        incoming.setAttribute('src', src);
      }

      // L'index se déduit de la position : revenir en arrière ramène
      // la photo qu'on avait sous les yeux, sans nouveau tirage.
      function photoAt(index) {
        if (!deck.length) return;
        // Une photo déjà posée par la reprise de session vaut amorçage :
        // l'ouverture du modal ne doit pas la remplacer par la première.
        amorce = true;
        var i = ((index % deck.length) + deck.length) % deck.length;
        swapTo(deck[i]);
        var next = deck[(i + 1) % deck.length];
        if (next) { var pre = new Image(); pre.src = sized(next); }
      }



      var step = 0;
      var answers = {};
      var history = [];
      var selection = [];
      var later = [];
      var gammeKey = null;

      function showPanel(name) {
        Object.keys(panels).forEach(function (k) { panels[k].classList.toggle('is-active', k === name); });
        root.classList.toggle('is-quiz', name === 'quiz');
      }

      function toTop() {
        var stage = root.querySelector('.mon-diag__stage');
        if (stage) stage.scrollTop = 0;
        var dialog = root.closest('[data-mon-diag-dialog]');
        if (dialog) dialog.scrollTop = 0;
      }

      // Une clause s'écrit « clé:valeur|valeur ». Plusieurs clauses se
      // séparent par « ; » : toutes doivent être vraies dans data-when,
      // une seule suffit dans data-when-any.
      function clause(spec) {
        var p = spec.split(':');
        return (p[1] || '').split('|').indexOf(answers[(p[0] || '').trim()]) !== -1;
      }

      function isEligible(q) {
        var when = q.dataset.when;
        if (when && !when.split(';').every(clause)) return false;
        var any = q.dataset.whenAny;
        if (any && !any.split(';').some(clause)) return false;
        return true;
      }

      function list() { return allQuestions.filter(isEligible); }

      function render() {
        var qs = list();
        if (step >= qs.length) step = qs.length - 1;
        allQuestions.forEach(function (q) { q.classList.remove('is-active'); });
        var active = qs[step];
        if (!active) return;
        active.classList.add('is-active');

        // La réponse déjà donnée reste visible quand on revient en arrière.
        active.querySelectorAll('.mon-diag__opt').forEach(function (opt) {
          opt.classList.toggle('is-on', answers[active.dataset.q] === opt.dataset.key);
        });

        if (progress) progress.style.width = (((step + 1) / (qs.length + 1)) * 100) + '%';
        backBtns.forEach(function (b) { b.disabled = step === 0; });
        if (requiredEl) requiredEl.hidden = true;

        var why = active.dataset.why || WHY[active.dataset.q];
        if (whyWrap && whyBody) {
          whyWrap.hidden = !why;
          whyBody.textContent = why || '';
        }

        var note = active.dataset.note;
        if (noteEl) {
          noteEl.hidden = !note;
          noteEl.textContent = note || '';
        }

        photoAt(Math.floor(step / photoEvery));
        toTop();
      }

      // La phrase « parce que » de la réponse donnée à une question.
      function because(key) {
        var q = first(allQuestions, function (x) { return x.dataset.q === key; });
        if (!q) return '';
        var opt = first(Array.prototype.slice.call(q.querySelectorAll('.mon-diag__opt')), function (o) {
          return o.dataset.key === answers[key];
        });
        return opt ? (opt.dataset.because || '') : '';
      }

      // ---------- La gamme ----------
      // Ce que l'on voit d'abord décide. Pour un teint terne, c'est la
      // sensation de fin de journée qui tranche : une peau qui tiraille
      // ou qui brille manque d'eau, une peau sèche ou confortable
      // manque de nutrition.
      function gammeFor() {
        var s = answers.signe;
        var r = answers.ressenti;
        if (s === 'rides') return 'sublime';
        if (s === 'ridules') return 'hydratation';
        if (s === 'secheresse') return 'nourrissante';
        if (r === 'tiraille' || r === 'brille') return 'hydratation';
        return 'nourrissante';
      }

      function cardFor(soin) {
        return first(cards, function (c) { return c.dataset.soin === soin; });
      }

      // ---------- Sélection ----------
      // Un soin n'entre que si une réponse le justifie, et chacun porte
      // sa raison. Ce qui dépasse le nombre de gestes choisi n'est pas
      // vendu : il est proposé « pour plus tard ».
      function build() {
        gammeKey = gammeFor();
        var g = GAMMES[gammeKey];
        var picks = [];

        picks.push({ soin: g.soins[0], why: because('signe') });

        var sensation = because('ressenti');
        var accord = (answers.ressenti === 'tiraille' && gammeKey === 'hydratation')
          || (answers.ressenti === 'seche' && gammeKey === 'nourrissante');
        picks.push({ soin: g.soins[1], why: accord ? sensation : 'Le complément du premier soin, dans la même gamme.' });

        // Teint terne et peau sèche : l'éclat vient de l'huile, le
        // confort de la crème. Les deux raisons changent de place.
        if (answers.signe === 'terne' && gammeKey === 'nourrissante' && accord) {
          picks[0].why = sensation;
          picks[1].why = because('signe');
        }

        var y = answers.yeux;
        if (y && y !== 'rien') {
          picks.push({
            soin: y === 'cernes' ? 'regard_hydra' : (y === 'ridules' ? 'regard_sa' : g.regard),
            why: because('yeux')
          });
        }

        if (answers.nettoyage === 'tiraille' || answers.nettoyage === 'aucun') {
          picks.push({ soin: 'lait', why: because('nettoyage') });
        }

        if ((answers.vie === 'menopause' || answers.vie === 'apres') && g.soins.indexOf('huile') === -1) {
          picks.push({ soin: 'huile', why: because('vie') });
        }

        var max = answers.gestes === 'un' ? 1 : (answers.gestes === 'deux' ? 2 : 5);
        selection = [];
        later = [];
        picks.forEach(function (p) {
          var c = cardFor(p.soin);
          if (!c || selection.indexOf(c) !== -1 || later.indexOf(c) !== -1) return;
          c.dataset.because = p.why || '';
          if (selection.length < max) selection.push(c);
          else later.push(c);
        });

        selection.sort(function (a, b) {
          return STEP_ORDER.indexOf(a.dataset.etape) - STEP_ORDER.indexOf(b.dataset.etape);
        });
      }

      function renderList() {
        if (!listEl) return;
        listEl.innerHTML = '';
        selection.forEach(function (card) {
          var stepEl = card.querySelector('[data-card-step]');
          if (stepEl) {
            var m = MOMENT_LABEL[card.dataset.moment] || '';
            stepEl.textContent = (STEP_LABEL[card.dataset.etape] || '') + (m ? ' · ' + m : '');
          }
          var becauseEl = card.querySelector('[data-card-because]');
          if (becauseEl) {
            becauseEl.textContent = card.dataset.because || '';
            becauseEl.hidden = !card.dataset.because;
          }
          listEl.appendChild(card);
        });
      }

      var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      // « Pour aller plus loin » : les soins justifiés par une réponse
      // mais au-delà du nombre de gestes choisi. Un clic les ajoute au
      // panier sans quitter le résultat.
      function renderLater() {
        if (!laterEl || !laterList) return;
        laterList.innerHTML = '';
        later.forEach(function (card) {
          var li = document.createElement('li');
          li.className = 'mon-diag__more-item';
          var link = card.querySelector('.mon-diag__card-foot a');
          var href = link ? link.getAttribute('href') : null;
          var title = card.querySelector('.mon-diag__card-title');
          var img = card.querySelector('img.mon-diag__card-img');
          var price = card.querySelector('.mon-diag__card-price');

          if (img) {
            var thumb = document.createElement('img');
            thumb.className = 'mon-diag__more-img';
            thumb.src = img.currentSrc || img.src;
            thumb.alt = '';
            thumb.width = 56; thumb.height = 56;
            li.appendChild(thumb);
          } else {
            var ph = document.createElement('span');
            ph.className = 'mon-diag__more-img';
            li.appendChild(ph);
          }

          var body = document.createElement('div');
          var name = document.createElement('p');
          name.className = 'mon-diag__more-name';
          if (href) {
            var a = document.createElement('a');
            a.href = href;
            a.textContent = title ? title.textContent : '';
            name.appendChild(a);
          } else {
            name.textContent = title ? title.textContent : '';
          }
          body.appendChild(name);
          if (card.dataset.because) {
            var why = document.createElement('p');
            why.className = 'mon-diag__more-why';
            why.textContent = card.dataset.because;
            body.appendChild(why);
          }
          li.appendChild(body);

          var buy = document.createElement('div');
          buy.className = 'mon-diag__more-buy';
          if (price) {
            var pr = document.createElement('span');
            pr.textContent = money(parseInt(card.dataset.price, 10) || 0);
            buy.appendChild(pr);
          }
          if (card.dataset.variant) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'mon-diag__more-add';
            btn.innerHTML = PLUS;
            btn.setAttribute('aria-label', 'Ajouter ' + (title ? title.textContent : 'ce soin') + ' au panier');
            btn.addEventListener('click', function () {
              if (btn.classList.contains('is-done')) return;
              btn.disabled = true;
              window.fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(card.dataset.variant), quantity: 1 }] })
              }).then(function (r) {
                if (!r.ok) throw new Error('cart');
                btn.classList.add('is-done');
                btn.innerHTML = CHECK;
                btn.setAttribute('aria-label', (title ? title.textContent : 'Soin') + ' ajouté au panier');
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              }).catch(function () {}).then(function () { btn.disabled = false; });
            });
            buy.appendChild(btn);
          }
          li.appendChild(buy);
          laterList.appendChild(li);
        });
        laterEl.hidden = later.length === 0;
      }

      // Un coffret remplace les soins qu'il contient quand ils sont tous
      // dans la routine. On retient d'abord celui qui fait économiser le
      // plus, puis on recommence sur ce qui reste.
      function packs(buyable) {
        var rest = buyable.map(function (c) { return c.dataset.variant; });
        var price = {};
        buyable.forEach(function (c) { price[c.dataset.variant] = parseInt(c.dataset.price, 10) || 0; });
        var chosen = [];
        for (;;) {
          var best = null;
          coffrets.forEach(function (k) {
            var inside = (k.dataset.contenu || '').split(',').filter(Boolean);
            if (inside.length < 2 || !inside.every(function (id) { return rest.indexOf(id) !== -1; })) return;
            var valeur = inside.reduce(function (sum, id) { return sum + price[id]; }, 0);
            var gain = valeur - (parseInt(k.dataset.price, 10) || 0);
            if (gain > 0 && (!best || gain > best.gain)) best = { el: k, inside: inside, valeur: valeur, gain: gain };
          });
          if (!best) break;
          chosen.push(best);
          rest = rest.filter(function (id) { return best.inside.indexOf(id) === -1; });
        }
        return { chosen: chosen, rest: rest };
      }

      function renderBuy() {
        if (!buyEl) return;
        var buyable = selection.filter(function (c) { return c.dataset.variant; });
        if (!buyable.length) { buyEl.hidden = true; return; }
        var total = buyable.reduce(function (sum, c) { return sum + parseInt(c.dataset.price, 10); }, 0);
        var plan = packs(buyable);
        var gain = plan.chosen.reduce(function (sum, p) { return sum + p.gain; }, 0);
        if (totalEl) totalEl.textContent = money(total - gain);

        if (offerEl) {
          offerEl.innerHTML = '';
          if (plan.chosen.length) {
            plan.chosen.forEach(function (p, i) {
              if (i) offerEl.appendChild(document.createTextNode(' + '));
              var a = document.createElement('a');
              a.href = p.el.dataset.url;
              a.textContent = p.el.dataset.title;
              offerEl.appendChild(a);
            });
            offerEl.appendChild(document.createTextNode(' inclus · '));
            var s = document.createElement('s');
            s.textContent = money(total);
            offerEl.appendChild(s);
            offerEl.appendChild(document.createTextNode(' · '));
            var b = document.createElement('b');
            b.textContent = money(gain) + ' d\'économie';
            offerEl.appendChild(b);
          }
          offerEl.hidden = plan.chosen.length === 0;
        }

        var label = root.querySelector('[data-diag-add-label]');
        if (label) label.textContent = buyable.length > 1 ? 'Ajouter ma routine au panier' : 'Ajouter ce soin au panier';
        buyEl.hidden = false;
        buyEl.dataset.variants = plan.chosen.map(function (p) { return p.el.dataset.variant; })
          .concat(plan.rest).join(',');
      }

      function renderCautions() {
        if (!cautionsEl || !cautionsList) return;
        var notes = [];
        var has = function (soin) { return selection.some(function (c) { return c.dataset.soin === soin; }); };
        if (answers.vie === 'menopause' || answers.vie === 'apres') {
          notes.push("Autour de la ménopause, la peau devient souvent plus sèche et plus fine. Appliquez vos soins matin et soir : c'est la régularité qui fait la différence.");
        }
        if (answers.nettoyage === 'tiraille' && !has('lait')) {
          notes.push("Votre peau tiraille après le nettoyage : votre nettoyant est sans doute trop décapant. Choisissez-en un plus doux.");
        }
        if (answers.ressenti === 'brille' && gammeKey !== 'hydratation') {
          notes.push("Votre peau brille en fin de journée : le matin, une noisette de crème suffit.");
        }
        cautionsList.innerHTML = '';
        notes.forEach(function (t) {
          var para = document.createElement('p');
          para.textContent = t;
          cautionsList.appendChild(para);
        });
        cautionsEl.hidden = notes.length === 0;
      }

      function renderHead() {
        var g = GAMMES[gammeKey];
        if (resultTitle) resultTitle.textContent = 'Votre routine ' + g.nom;
        if (resultLede) resultLede.textContent = g.texte;
      }

      // L'état du diagnostic survit au rechargement provoqué par l'envoi
      // du formulaire client.
      var STORE_KEY = 'mon-diag-etat';

      function saveState() {
        try {
          window.sessionStorage.setItem(STORE_KEY, JSON.stringify({ answers: answers, t: Date.now() }));
        } catch (e) {}
      }

      function loadState() {
        try {
          var raw = window.sessionStorage.getItem(STORE_KEY);
          if (!raw) return false;
          var data = JSON.parse(raw);
          window.sessionStorage.removeItem(STORE_KEY);
          if (!data || !data.answers || !data.answers.signe) return false;
          // Un état vieux de plus de dix minutes n'a plus de raison de
          // rouvrir le résultat au visage de quelqu'un qui revient.
          if (!data.t || Date.now() - data.t > 600000) return false;
          answers = data.answers;
          return true;
        } catch (e) { return false; }
      }

      function showResult() {
        cards.forEach(function (c) { if (pool) pool.appendChild(c); });
        build();
        renderList();
        renderBuy();
        renderLater();
        renderCautions();
        renderHead();
        if (deck.length) photoAt(Math.floor(step / photoEvery) + 1);
        showPanel('result');
        toTop();
      }

      function advance() {
        var qs = list();
        if (step < qs.length - 1) { step += 1; render(); }
        else showResult();
      }

      function answer(btn) {
        var q = btn.closest('.mon-diag__q');
        var key = q ? q.dataset.q : null;
        if (!key) return;
        history.push({ key: key, previous: answers[key] });
        answers[key] = btn.dataset.key || '';
        advance();
      }

      function next() {
        var active = list()[step];
        if (!active) return;
        if (!answers[active.dataset.q]) {
          if (requiredEl) requiredEl.hidden = false;
          return;
        }
        advance();
      }

      function back() {
        var last = history.pop();
        if (last) {
          if (last.previous === undefined) delete answers[last.key];
          else answers[last.key] = last.previous;
        }
        step = Math.max(0, step - 1);
        render();
      }

      function restart() {
        step = 0; answers = {}; history = []; selection = []; later = [];
        cards.forEach(function (c) { if (pool) pool.appendChild(c); });
        if (listEl) listEl.innerHTML = '';
        if (buyEl) buyEl.hidden = true;
        if (laterEl) laterEl.hidden = true;
        if (cautionsEl) cautionsEl.hidden = true;
        if (emailInput) emailInput.value = '';
        if (deck.length) { shuffle(); photoAt(0); }
        else if (mediaImg && introImage) mediaImg.setAttribute('src', introImage);
        render();
        showPanel('intro');
        toTop();
      }

      root.querySelectorAll('[data-diag-start]').forEach(function (b) {
        b.addEventListener('click', function () { showPanel('quiz'); render(); });
      });
      root.querySelectorAll('.mon-diag__opt').forEach(function (b) {
        b.addEventListener('click', function () { answer(b); });
      });
      if (nextBtn) nextBtn.addEventListener('click', next);
      backBtns.forEach(function (b) { b.addEventListener('click', back); });

      if (emailForm) {
        emailForm.addEventListener('submit', function (event) {
          var value = (emailInput.value || '').trim();
          if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(value)) {
            event.preventDefault();
            if (emailError) emailError.hidden = false;
            emailInput.focus();
            return;
          }
          if (tagsInput) tagsInput.value = 'diagnostic,newsletter' + (gammeKey ? ',diag-' + gammeKey : '');
          saveState();
        });
      }
      root.querySelectorAll('[data-diag-restart]').forEach(function (b) {
        b.addEventListener('click', restart);
      });

      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          var ids = (buyEl.dataset.variants || '').split(',').filter(Boolean);
          if (!ids.length) return;
          buyBtn.disabled = true;
          window.fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { buyBtn.disabled = false; });
        });
      }

      // Rien n'est téléchargé tant que le diagnostic n'est pas ouvert :
      // la majorité des visiteurs de l'accueil ne l'ouvriront pas. Et
      // dans un <dialog> fermé, le chargement différé natif ne part
      // jamais — c'est donc à nous de déclencher le premier visuel.
      var amorce = false;

      function prime() {
        if (amorce) return;
        amorce = true;
        if (deck.length) photoAt(0);
        else swapTo(introImage);
      }

      var dlg = root.closest('[data-mon-diag-dialog]');
      if (dlg) dlg.addEventListener('mon-diag:open', prime);
      else prime();

      if (loadState()) {
        // Retour du formulaire : on rouvre le résultat et on remercie.
        if (/[?&]customer_posted=true/.test(window.location.search)) {
          if (emailForm) emailForm.hidden = true;
          if (keepText) keepText.hidden = true;
          if (thanksEl) thanksEl.hidden = false;
        }
        showResult();
        var dialog = root.closest('[data-mon-diag-dialog]');
        if (dialog && !dialog.open) {
          dialog.showModal();
          dialog.dispatchEvent(new CustomEvent('mon-diag:open'));
          document.body.classList.add('mon-diag-modal-open');
        }
      } else {
        render();
      }
    }

    function boot() {
      document.querySelectorAll('[data-mon-diag]').forEach(init);
      document.querySelectorAll('[data-mon-diag-dialog]').forEach(function (dialog) {
        if (dialog.dataset.modalReady === '1') return;
        dialog.dataset.modalReady = '1';
        var previousFocus = null;
        var open = function (trigger) {
          if (dialog.open) return;
          previousFocus = trigger || document.activeElement;
          dialog.showModal();
          dialog.dispatchEvent(new CustomEvent('mon-diag:open'));
          document.body.classList.add('mon-diag-modal-open');
          var f = dialog.querySelector('[data-mon-diag-close]');
          if (f) f.focus();
        };
        var close = function () { if (dialog.open) dialog.close(); };
        document.addEventListener('click', function (event) {
          var trigger = event.target.closest('[data-open-diagnostic], a[href="#diagnostic"], a[href$="/#diagnostic"]');
          if (!trigger) return;
          event.preventDefault();
          open(trigger);
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && dialog.open) { event.preventDefault(); close(); }
        });
        dialog.querySelector('[data-mon-diag-close]')?.addEventListener('click', close);
        dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
        dialog.addEventListener('close', function () {
          document.body.classList.remove('mon-diag-modal-open');
          if (window.location.hash === '#diagnostic') history.replaceState(null, '', window.location.pathname + window.location.search);
          if (previousFocus && previousFocus.focus) previousFocus.focus();
        });
        var fromHash = function () { if (window.location.hash === '#diagnostic') open(null); };
        window.addEventListener('hashchange', fromHash);
        fromHash();
      });
    }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-gammes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.monGammesReady === 'true') return;
      root.dataset.monGammesReady = 'true';

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-visible');
            observer.disconnect();
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-mon-gammes]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-mon-gammes]')
        : null;
      if (root) {
        root.dataset.monGammesReady = 'false';
        init(root);
      } else {
        boot(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-grille"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.grReady === '1') return;
      root.dataset.grReady = '1';

      var pills    = Array.prototype.slice.call(root.querySelectorAll('[data-gr-jump]'));
      var toggle   = root.querySelector('[data-gr-toggle]');
      var panel    = root.querySelector('[data-gr-panel]');
      var badge    = root.querySelector('[data-gr-active]');
      var clearBtn = root.querySelector('[data-gr-clear]');
      var countEl  = root.querySelector('[data-gr-count]');
      var noneEl   = root.querySelector('[data-gr-none]');
      var boxes    = Array.prototype.slice.call(root.querySelectorAll('.mon-gr__box'));
      var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-gr-chapter]'));

      // Les pastilles font défiler, elles ne filtrent pas : la page
      // reste entière et le client garde ses repères.
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.toggle('is-on', p === pill); });
          var target = pill.dataset.grJump;
          if (target === '*') {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          var el = root.querySelector('#' + CSS.escape(target));
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      function apply() {
        var picked = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
        var total = 0;

        chapters.forEach(function (ch) {
          var tiles = Array.prototype.slice.call(ch.querySelectorAll('.mon-gr__tile'));
          var shown = 0;
          tiles.forEach(function (t) {
            var tags = t.dataset.tags || '';
            var ok = picked.length === 0 || picked.some(function (v) {
              return tags.indexOf('~' + v + '~') > -1;
            });
            t.hidden = !ok;
            if (ok) shown += 1;
          });
          total += shown;
          ch.hidden = shown === 0;
        });

        if (countEl) countEl.textContent = String(total);
        if (noneEl) noneEl.hidden = total !== 0;
        if (clearBtn) clearBtn.hidden = picked.length === 0;
        if (badge) {
          badge.hidden = picked.length === 0;
          badge.textContent = String(picked.length);
        }
      }

      boxes.forEach(function (b) { b.addEventListener('change', apply); });

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = panel.hidden;
          panel.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          boxes.forEach(function (b) { b.checked = false; });
          apply();
        });
      }

      apply();
    }

    function boot() { document.querySelectorAll('[data-mon-gr]').forEach(init); }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-header"]) return;
  try {
    
  (function () {
    var HOVER_OPEN_MS = 140;
    var HOVER_CLOSE_MS = 180;

    function initMonHeader(root) {
      if (!root || root.dataset.monHeaderReady === 'true') return;
      root.dataset.monHeaderReady = 'true';

      var threshold = Number(root.dataset.scrollThreshold || 60);
      var slot = root.querySelector('[data-mon-mega-slot]');
      var host = root.querySelector('[data-mon-mega-host]');
      var backdrop = root.querySelector('[data-mon-backdrop]');
      var drawer = root.querySelector('[data-mon-drawer]');
      var drawerOpenBtn = root.querySelector('[data-mon-drawer-open]');
      var drawerCloseBtn = root.querySelectorAll('[data-mon-drawer-close]');
      var items = root.querySelectorAll('[data-mon-mega-item]');
      var openTimer;
      var closeTimer;
      var activeItem = null;

      function setScrolled() {
        root.classList.toggle('is-scrolled', window.scrollY > threshold);
      }

      function setHeaderGroupHeight() {
        var group = document.getElementById('header-group');
        var groupHeight = group ? group.offsetHeight : root.offsetHeight;
        var navHeight = root.offsetHeight;
        document.documentElement.style.setProperty('--mon-header-group-height', groupHeight + 'px');
        document.documentElement.style.setProperty('--mon-header-height', navHeight + 'px');
      }

      function closeMega() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        if (activeItem) {
          var trigger = activeItem.querySelector('[data-mon-mega-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
        activeItem = null;
        if (host) host.innerHTML = '';
        if (slot) {
          slot.hidden = true;
          slot.setAttribute('inert', '');
        }
        root.classList.remove('is-mega-open');
        if (backdrop) backdrop.hidden = true;
      }

      function openMega(item) {
        if (!item || !host || !slot) return;
        var trigger = item.querySelector('[data-mon-mega-trigger]');
        var panelId = trigger && trigger.getAttribute('data-panel-id');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        if (activeItem && activeItem !== item) {
          var prevTrigger = activeItem.querySelector('[data-mon-mega-trigger]');
          if (prevTrigger) prevTrigger.setAttribute('aria-expanded', 'false');
        }

        activeItem = item;
        if (trigger) trigger.setAttribute('aria-expanded', 'true');

        var clone = panel.cloneNode(true);
        clone.removeAttribute('id');
        clone.hidden = false;
        clone.removeAttribute('inert');
        host.innerHTML = '';
        host.appendChild(clone);

        slot.hidden = false;
        slot.removeAttribute('inert');
        root.classList.add('is-mega-open');
        if (backdrop && root.dataset.dimBackdrop === 'true') {
          backdrop.hidden = false;
        }
      }

      function scheduleOpen(item) {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          openMega(item);
        }, HOVER_OPEN_MS);
      }

      function scheduleClose() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMega, HOVER_CLOSE_MS);
      }

      items.forEach(function (item) {
        item.addEventListener('pointerenter', function () {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          scheduleOpen(item);
        });
        item.addEventListener('pointerleave', function () {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          scheduleClose();
        });

        var trigger = item.querySelector('[data-mon-mega-trigger]');
        if (trigger) {
          trigger.addEventListener('click', function (event) {
            if (window.matchMedia('(max-width: 989px)').matches) return;
            event.preventDefault();
            if (activeItem === item) {
              closeMega();
            } else {
              openMega(item);
            }
          });
          trigger.addEventListener('focus', function () {
            if (window.matchMedia('(max-width: 989px)').matches) return;
            scheduleOpen(item);
          });
        }
      });

      if (slot) {
        slot.addEventListener('pointerenter', function () {
          clearTimeout(closeTimer);
        });
        slot.addEventListener('pointerleave', scheduleClose);
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeMega();
          if (drawer && drawer.open) drawer.close();
        }
      });

      document.addEventListener('pointerdown', function (event) {
        if (!root.classList.contains('is-mega-open')) return;
        if (!root.contains(event.target)) closeMega();
      });

      if (backdrop) {
        backdrop.addEventListener('click', closeMega);
      }

      if (drawer && drawerOpenBtn) {
        drawerOpenBtn.addEventListener('click', function () {
          closeMega();
          if (typeof drawer.showModal === 'function') drawer.showModal();
        });
      }

      drawerCloseBtn.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (drawer) drawer.close();
        });
      });

      if (drawer) {
        drawer.addEventListener('click', function (event) {
          if (event.target === drawer) drawer.close();
        });
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setScrolled();
          ticking = false;
        });
      }

      setScrolled();
      setHeaderGroupHeight();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          setHeaderGroupHeight();
          if (window.matchMedia('(max-width: 989px)').matches) closeMega();
        },
        { passive: true }
      );
    }

    function initAll() {
      document.querySelectorAll('[data-mon-header]').forEach(initMonHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (!section) return;
      var header = section.querySelector('[data-mon-header]');
      if (header) {
        header.dataset.monHeaderReady = 'false';
        initMonHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-hero-carrousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MIN_DELAY = 2500;

    function init(root) {
      if (!root || root.dataset.mhcReady === 'true') return;
      root.dataset.mhcReady = 'true';

      const viewport = root.querySelector('[data-mhc-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-mhc-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-mhc-dot]'));
      const previous = root.querySelector('[data-mhc-prev]');
      const nextButton = root.querySelector('[data-mhc-next]');
      const status = root.querySelector('[data-mhc-status]');

      if (slides.length < 2) return;

      // Images différées des diapositives 2 et suivantes : on rend leurs
      // adresses dès que la première image est arrivée (ou au plus tard au
      // chargement de la page, ou à la première interaction), bien avant
      // l'enchaînement automatique (2,5 s minimum).
      let differe = Array.from(root.querySelectorAll('[data-mhc-differe], source[data-srcset]'));
      function reveler() {
        if (!differe.length) return;
        differe.forEach((el) => {
          if (el.dataset.srcset) el.setAttribute('srcset', el.dataset.srcset);
          if (el.dataset.src) el.setAttribute('src', el.dataset.src);
          delete el.dataset.srcset;
          delete el.dataset.src;
        });
        differe = [];
      }
      const premiere = slides[0].querySelector('img');
      if (premiere && premiere.complete && premiere.naturalWidth) window.setTimeout(reveler, 150);
      else if (premiere) premiere.addEventListener('load', () => window.setTimeout(reveler, 150), { once: true });
      if (document.readyState === 'complete') window.setTimeout(reveler, 400);
      else window.addEventListener('load', () => window.setTimeout(reveler, 400), { once: true });
      window.setTimeout(reveler, 4000);
      ['pointerdown', 'touchstart', 'keydown'].forEach((type) => root.addEventListener(type, reveler, { once: true, passive: true }));

      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Math.max(MIN_DELAY, parseInt(root.dataset.mhcDelay, 10) || 6500);

      let current = 0;
      let timer = null;
      let hovered = false;
      let onScreen = true;
      let stopped = root.dataset.mhcAutoplay !== 'true' || motionQuery.matches;

      function canPlay() {
        return !stopped && !hovered && onScreen && !document.hidden;
      }

      function clear() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function play() {
        clear();
        if (!canPlay()) return;
        timer = window.setInterval(() => show(current + 1), delay);
      }

      // Une interaction explicite rend la main au visiteur : on n'enchaîne plus
      // les slides dans son dos.
      function stop() {
        stopped = true;
        clear();
      }

      function show(index, announce) {
        current = ((index % slides.length) + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        // Les points et les flèches vivent hors des slides : on leur repasse la
        // couleur de texte de la slide affichée, sinon ils disparaissent sur un
        // visuel sombre.
        const ink = slides[current].style.getPropertyValue('--mhc-ink');
        if (ink) root.style.setProperty('--mhc-ink-nav', ink.trim());

        // On n'annonce que les changements demandés : un défilement automatique
        // qui parle toutes les 6 secondes rend un lecteur d'écran inutilisable.
        if (announce && status) {
          status.textContent = `${current + 1} / ${slides.length}`;
        }
      }

      function goTo(index) {
        stop();
        show(index, true);
      }

      previous?.addEventListener('click', () => goTo(current - 1));
      nextButton?.addEventListener('click', () => goTo(current + 1));
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => goTo(dotIndex));
      });

      viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(current - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(current + 1);
        }
      });

      const pause = () => {
        hovered = true;
        clear();
      };
      const resume = () => {
        hovered = false;
        play();
      };

      viewport?.addEventListener('pointerenter', pause);
      viewport?.addEventListener('pointerleave', resume);
      viewport?.addEventListener('focusin', pause);
      viewport?.addEventListener('focusout', (event) => {
        if (!viewport.contains(event.relatedTarget)) resume();
      });

      let touchX = 0;
      let touchY = 0;

      viewport?.addEventListener(
        'touchstart',
        (event) => {
          touchX = event.changedTouches[0].clientX;
          touchY = event.changedTouches[0].clientY;
        },
        { passive: true }
      );

      viewport?.addEventListener(
        'touchend',
        (event) => {
          const deltaX = event.changedTouches[0].clientX - touchX;
          const deltaY = event.changedTouches[0].clientY - touchY;
          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          goTo(deltaX > 0 ? current - 1 : current + 1);
        },
        { passive: true }
      );

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clear();
        } else {
          play();
        }
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              onScreen = entry.isIntersecting;
              if (onScreen) {
                play();
              } else {
                clear();
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(root);
      }

      motionQuery.addEventListener?.('change', (event) => {
        if (event.matches) stop();
      });

      document.addEventListener('shopify:block:select', (event) => {
        const target = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (!target) return;
        const targetIndex = Number(target.dataset.index);
        if (Number.isNaN(targetIndex)) return;
        goTo(targetIndex);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) clear();
      });

      show(0, false);
      play();
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-mhc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.monHeroVideoReady === 'true') return;
      root.dataset.monHeroVideoReady = 'true';

      var video = root.querySelector('[data-mon-hero-video]');
      if (!video) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.pause();
        return;
      }

      function revealVideo() {
        root.classList.add('is-video-ready');
      }

      video.addEventListener('loadeddata', revealVideo, { once: true });
      video.addEventListener('playing', revealVideo, { once: true });

      if (video.readyState >= 2) revealVideo();

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function boot() {
      document.querySelectorAll('[data-mon-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-mon-hero]')
        : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-manifeste"] && !Shopify.designMode) return;
  try {
    
  /* Comme chez Ganaé, aucun évènement `scroll` ni observateur : une
     boucle requestAnimationFrame relit la position des lignes à
     chaque image. C'est indispensable ici, où le défilement est porté
     par `div.page-wrapper` (html et body sont en overflow: hidden) et
     non par la fenêtre. Loin de l'écran, la boucle se contente d'une
     mesure par image. Un lissage (environ 22 % de l'écart par image)
     fait glisser le remplissage même quand une molette avance par
     crans. Le navigateur suspend la boucle quand l'onglet est caché. */
  class MonManifeste extends HTMLElement {
    connectedCallback() {
      this.texte = this.querySelector('[data-mmn-texte]');
      if (!this.texte) return;

      if (!this.mots) this.mots = this.decouper(this.texte);
      this.lignes = [];
      this.valeurs = [];
      this.raf = 0;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('mmn--fixe');
        this.repartir();
        return;
      }

      this.onResize = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (window.innerWidth === this.largeur) this.peindre(true);
          else this.repartir();
        }, 120);
      };
      window.addEventListener('resize', this.onResize);

      this.repartir();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.isConnected && this.repartir());
      }

      const boucle = () => {
        if (!this.isConnected) return;
        const vh = window.innerHeight || 1;
        const r = this.getBoundingClientRect();
        const proche = r.bottom > -400 && r.top < vh + 400;
        if (proche) {
          this.peindre(false);
        } else if (!this.pose) {
          this.peindre(true); // hors écran : on fige l'état final
          this.pose = true;
        }
        if (proche) this.pose = false;
        this.raf = requestAnimationFrame(boucle);
      };
      this.raf = requestAnimationFrame(boucle);
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.timer);
    }

    /* Découpe le contenu en mots, espaces et traits d'union, chacun
       dans son span, pour mesurer où tombent les retours à la ligne. */
    decouper(el) {
      const mots = [];
      el.childNodes.forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE) {
          (n.textContent.match(/(\s+|[^\s-]+|-)/g) || []).forEach((m) => {
            const span = document.createElement('span');
            span.textContent = m;
            mots.push(span);
          });
        } else if (n.nodeType === Node.ELEMENT_NODE) {
          mots.push(n);
        }
      });
      return mots;
    }

    /* Remet tous les mots à plat, mesure leur position, puis regroupe
       ceux qui partagent la même hauteur en une ligne. */
    repartir() {
      const el = this.texte;
      this.largeur = window.innerWidth;
      el.replaceChildren(...this.mots);

      const lignes = [];
      let courante = [];
      let milieuPrec = null;
      this.mots.forEach((m) => {
        const r = m.getBoundingClientRect();
        if (!r.width) return; // espace avalé par un retour à la ligne
        const milieu = (r.top + r.bottom) / 2;
        if (milieuPrec !== null && Math.abs(milieu - milieuPrec) > 10) {
          lignes.push(courante);
          courante = [];
        }
        courante.push(m);
        milieuPrec = milieu;
      });
      if (courante.length) lignes.push(courante);

      const frag = document.createDocumentFragment();
      this.lignes = lignes.map((mots) => {
        const ligne = document.createElement('span');
        ligne.className = 'mmn__ligne';
        mots.forEach((m) => ligne.appendChild(m));
        frag.appendChild(ligne);
        return ligne;
      });
      el.replaceChildren(frag);
      this.valeurs = this.lignes.map(() => null);

      if (!this.classList.contains('mmn--fixe')) this.peindre(true);
    }

    /* Position de chaque ligne dans la fenêtre → taux de remplissage.
       Ligne 1 : de 70 % à 50 % de la hauteur de fenêtre ; chaque
       suivante démarre là où la précédente finit, décalée de sa
       propre hauteur. La valeur monte à 120 % : les 20 % de plus sont
       la largeur du bord fondu. `instant` saute directement à la
       cible ; sinon on s'en approche de 22 % par image. */
    peindre(instant) {
      if (!this.lignes.length) return;
      const vh = window.innerHeight || 1;
      const rects = this.lignes.map((l) => l.getBoundingClientRect());
      let debut = 0.7;
      let fin = 0.5;

      this.lignes.forEach((ligne, i) => {
        if (i > 0) {
          debut = fin + rects[i].height / vh;
          fin = Math.max(debut - 0.2, 0.2);
        }
        const pos = Math.max(Math.min(rects[i].top / vh, 1), 0);
        let cible;
        if (pos > debut) cible = 0;
        else if (pos < fin) cible = 120;
        else cible = (120 * (pos - debut)) / (fin - debut);

        let v = this.valeurs[i];
        if (instant || v === null) v = cible;
        else {
          v += (cible - v) * 0.22;
          if (Math.abs(cible - v) < 0.05) v = cible;
        }
        if (v === this.valeurs[i]) return;
        this.valeurs[i] = v;

        const w = rects[i].width;
        const plein = (w * v) / 100;
        ligne.style.setProperty('--mmn-a', plein - w * 0.2 + 'px');
        ligne.style.setProperty('--mmn-b', plein + 'px');
      });
    }
  }

  if (!customElements.get('mon-manifeste')) {
    customElements.define('mon-manifeste', MonManifeste);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-plante-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.monPlanteReady === 'true') return;
      root.dataset.monPlanteReady = 'true';

      var video = root.querySelector('[data-mon-plante-video]');
      var track = root.querySelector('.mon-plante-scroll__track');
      var args = root.querySelectorAll('[data-mon-plante-arg]');
      var intro = root.querySelector('[data-mon-plante-intro]');
      var scrollCue = root.querySelector('[data-mon-plante-scroll-cue]');
      var final = root.querySelector('[data-mon-plante-final]');
      var finalLink = final ? final.querySelector('a') : null;
      var finalLoop = root.querySelector('[data-mon-plante-final-loop]');
      var finalLoopStart = Number(root.dataset.finalLoopStart || 88);
      var progressLabel = root.querySelector('[data-mon-plante-progress]');
      var source = video ? video.querySelector('source') : null;
      var pageWrapper = root.closest('.page-wrapper');
      var motionStyle = root.dataset.motionStyle || 'guided';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ticking = false;
      var duration = 0;
      var targetTime = 0;
      var seekPending = false;
      var objectUrl = '';
      var finalLoopActive = false;

      if (!video || !track) return;

      function progress() {
        var rect = track.getBoundingClientRect();
        var total = track.offsetHeight - window.innerHeight;
        if (total <= 0) return 0;
        var scrolled = -rect.top;
        return Math.min(1, Math.max(0, scrolled / total));
      }

      function easeInOut(value) {
        return value * value * (3 - 2 * value);
      }

      function mapSegment(value, inputStart, inputEnd, outputStart, outputEnd) {
        var local = Math.min(1, Math.max(0, (value - inputStart) / (inputEnd - inputStart)));
        return outputStart + (outputEnd - outputStart) * easeInOut(local);
      }

      function videoProgress(rawProgress) {
        if (motionStyle !== 'guided') return rawProgress;
        if (rawProgress <= 0.12) return mapSegment(rawProgress, 0, 0.12, 0, 0.06);
        if (rawProgress <= 0.34) return mapSegment(rawProgress, 0.12, 0.34, 0.06, 0.36);
        if (rawProgress <= 0.4) return mapSegment(rawProgress, 0.34, 0.4, 0.36, 0.38);
        if (rawProgress <= 0.62) return mapSegment(rawProgress, 0.4, 0.62, 0.38, 0.67);
        if (rawProgress <= 0.68) return mapSegment(rawProgress, 0.62, 0.68, 0.67, 0.69);
        if (rawProgress <= 0.85) return mapSegment(rawProgress, 0.68, 0.85, 0.69, 0.93);
        return mapSegment(rawProgress, 0.85, 1, 0.93, 1);
      }

      function updateFinalLoop(pct) {
        if (!finalLoop) return;
        var shouldPlay = pct >= finalLoopStart;
        if (shouldPlay === finalLoopActive) return;
        finalLoopActive = shouldPlay;
        root.classList.toggle('is-final-loop-active', shouldPlay);
        if (shouldPlay) {
          var playPromise = finalLoop.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          finalLoop.pause();
          finalLoop.currentTime = 0;
        }
      }

      function updateStory(p) {
        var pct = p * 100;
        var activeStep = 0;

        args.forEach(function (el) {
          var start = Number(el.getAttribute('data-start-at') || 0);
          var end = Number(el.getAttribute('data-end-at') || 100);
          var active = pct >= start && pct < end;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) activeStep = Array.prototype.indexOf.call(args, el) + 1;
        });

        if (intro) {
          var introVisible = pct < 16;
          intro.classList.toggle('is-visible', introVisible);
          intro.setAttribute('aria-hidden', introVisible ? 'false' : 'true');
        }

        if (scrollCue) {
          scrollCue.classList.toggle('is-visible', pct < 11);
        }

        if (final) {
          var finalVisible = pct >= 85;
          final.classList.toggle('is-visible', finalVisible);
          final.setAttribute('aria-hidden', finalVisible ? 'false' : 'true');
          if (finalLink) finalLink.tabIndex = finalVisible ? 0 : -1;
        }
        updateFinalLoop(pct);

        root.dataset.activeStep = String(activeStep);
        root.style.setProperty('--mon-plante-progress', p.toFixed(4));
        if (progressLabel) {
          if (pct >= 85) {
            progressLabel.textContent = 'FIN';
          } else if (activeStep > 0) {
            progressLabel.textContent = String(activeStep).padStart(2, '0') + ' / 03';
          } else {
            progressLabel.textContent = '—';
          }
        }
      }

      function requestSeek() {
        if (!duration || seekPending) return;
        var safeTarget = Math.min(Math.max(targetTime, 0), Math.max(duration - 0.001, 0));
        if (Math.abs(video.currentTime - safeTarget) < 0.012) return;
        seekPending = true;
        try {
          video.currentTime = safeTarget;
        } catch (error) {
          seekPending = false;
        }
      }

      function update() {
        var p = progress();
        targetTime = videoProgress(p) * duration;
        updateStory(p);
        requestSeek();
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }

      function markReady() {
        if (video.duration && isFinite(video.duration)) {
          duration = video.duration;
        }
        video.pause();
        root.classList.add('is-ready');
        update();
      }

      video.addEventListener('seeked', function () {
        seekPending = false;
        requestSeek();
      });

      if (reduce) {
        if (finalLoop) finalLoop.pause();
        video.addEventListener('loadedmetadata', function () {
          duration = video.duration || 0;
          video.currentTime = Math.max(duration - 0.001, 0);
          root.classList.add('is-ready');
        }, { once: true });
        args.forEach(function (el) {
          el.classList.add('is-active');
          el.setAttribute('aria-hidden', 'false');
        });
        if (final) final.setAttribute('aria-hidden', 'false');
        if (finalLink) finalLink.tabIndex = 0;
        return;
      }

      async function prepareVideo() {
        var src = source ? source.src : video.currentSrc;
        if (window.matchMedia('(max-width: 749px)').matches) {
          src = video.dataset.mobileVideoSrc || src;
        } else {
          src = video.dataset.desktopVideoSrc || src;
        }
        if (!src) return;

        try {
          var response = await fetch(src, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Video request failed');
          var blob = await response.blob();
          objectUrl = URL.createObjectURL(blob);
          video.src = objectUrl;
          video.load();
          if (video.readyState >= 3) {
            markReady();
          } else {
            video.addEventListener('canplaythrough', markReady, { once: true });
          }
        } catch (error) {
          if (video.readyState >= 1) {
            markReady();
          } else {
            video.addEventListener('loadedmetadata', markReady, { once: true });
          }
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('pagehide', function () {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        if (finalLoop) finalLoop.pause();
      }, { once: true });
      prepareVideo();
      updateStory(progress());
    }

    function boot() {
      document.querySelectorAll('[data-mon-plante-scroll]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target && event.target.querySelector
        ? event.target.querySelector('[data-mon-plante-scroll]')
        : null;
      if (section) {
        section.dataset.monPlanteReady = 'false';
        init(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-premium-header"]) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.monPremiumHeaderReady === 'true') return;
      root.dataset.monPremiumHeaderReady = 'true';

      var trigger = root.querySelector('[data-mon-premium-mega-trigger]');
      var mega = root.querySelector('[data-mon-premium-mega]');
      var megaClose = root.querySelector('[data-mon-premium-mega-close]');
      var submenuTriggers = Array.from(root.querySelectorAll('[data-mon-premium-submenu-trigger]'));
      var backdrop = root.querySelector('[data-mon-premium-backdrop]');
      var drawer = root.querySelector('[data-mon-premium-drawer]');
      var drawerOpen = root.querySelector('[data-mon-premium-drawer-open]');
      var drawerClose = root.querySelector('[data-mon-premium-drawer-close]');
      var desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var closeTimer = 0;
      var hoverTimer = 0;
      var isOpen = false;
      var submenuTimer = 0;
      var submenuHideTimer = 0;
      var activeSubmenuTrigger = null;
      var activeSubmenuPanel = null;

      function clearTimers() {
        window.clearTimeout(closeTimer);
        window.clearTimeout(hoverTimer);
      }

      function clearSubmenuTimers() {
        window.clearTimeout(submenuTimer);
        window.clearTimeout(submenuHideTimer);
      }

      function panelForSubmenu(triggerElement) {
        if (!triggerElement) return null;
        var group = triggerElement.dataset.monPremiumSubmenuTrigger;
        return root.querySelector('[data-mon-premium-submenu="' + group + '"]');
      }

      function closeSubmenu(returnFocus, immediate) {
        if (!activeSubmenuTrigger || !activeSubmenuPanel) return;
        clearSubmenuTimers();
        var triggerToClose = activeSubmenuTrigger;
        var panelToClose = activeSubmenuPanel;
        activeSubmenuTrigger = null;
        activeSubmenuPanel = null;
        triggerToClose.setAttribute('aria-expanded', 'false');
        panelToClose.classList.remove('is-open');

        function finishSubmenuClose() {
          panelToClose.hidden = true;
          panelToClose.inert = true;
          if (returnFocus) triggerToClose.focus();
        }

        if (immediate || reduce) {
          finishSubmenuClose();
        } else {
          submenuHideTimer = window.setTimeout(finishSubmenuClose, 260);
        }
      }

      function openSubmenu(triggerElement) {
        if (!triggerElement || window.innerWidth < 990) return;
        var panel = panelForSubmenu(triggerElement);
        if (!panel || activeSubmenuTrigger === triggerElement) return;

        closeSubmenu(false, true);
        if (isOpen) {
          clearTimers();
          isOpen = false;
          trigger.setAttribute('aria-expanded', 'false');
          finishClose(false);
        }

        activeSubmenuTrigger = triggerElement;
        activeSubmenuPanel = panel;
        panel.hidden = false;
        panel.inert = false;
        triggerElement.setAttribute('aria-expanded', 'true');
        panel.getBoundingClientRect();
        panel.classList.add('is-open');
      }

      function scheduleSubmenuOpen(triggerElement) {
        if (!desktopHover.matches) return;
        clearSubmenuTimers();
        submenuTimer = window.setTimeout(function () {
          openSubmenu(triggerElement);
        }, 90);
      }

      function scheduleSubmenuClose() {
        if (!desktopHover.matches) return;
        clearSubmenuTimers();
        submenuTimer = window.setTimeout(function () {
          closeSubmenu(false, false);
        }, 180);
      }

      function openMega() {
        if (!trigger || !mega || window.innerWidth < 990 || isOpen) return;
        closeSubmenu(false, true);
        clearTimers();
        isOpen = true;
        mega.hidden = false;
        mega.inert = false;
        if (backdrop) backdrop.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        root.classList.remove('is-mega-closing');
        mega.getBoundingClientRect();
        root.classList.add('is-mega-open');
      }

      function finishClose(returnFocus) {
        root.classList.remove('is-mega-open', 'is-mega-closing');
        mega.hidden = true;
        mega.inert = true;
        if (backdrop) backdrop.hidden = true;
        if (returnFocus && trigger) trigger.focus();
      }

      function closeMega(returnFocus) {
        if (!mega || !isOpen) return;
        clearTimers();
        isOpen = false;
        trigger.setAttribute('aria-expanded', 'false');
        root.classList.add('is-mega-closing');
        closeTimer = window.setTimeout(function () {
          root.classList.remove('is-mega-open');
          closeTimer = window.setTimeout(function () {
            finishClose(returnFocus);
          }, reduce ? 0 : 280);
        }, reduce ? 0 : 160);
      }

      function scheduleOpen() {
        if (!desktopHover.matches) return;
        clearTimers();
        hoverTimer = window.setTimeout(openMega, 90);
      }

      function scheduleClose() {
        if (!desktopHover.matches) return;
        clearTimers();
        hoverTimer = window.setTimeout(function () {
          closeMega(false);
        }, 180);
      }

      if (trigger && mega) {
        trigger.addEventListener('click', function (event) {
          if (window.innerWidth < 990) return;
          event.preventDefault();
          openMega();
        });

        trigger.addEventListener('focus', function () {
          if (desktopHover.matches) openMega();
        });

        trigger.addEventListener('pointerenter', scheduleOpen);
        trigger.addEventListener('pointerleave', scheduleClose);
        mega.addEventListener('pointerenter', clearTimers);
        mega.addEventListener('pointerleave', scheduleClose);
      }

      submenuTriggers.forEach(function (submenuTrigger) {
        var submenuPanel = panelForSubmenu(submenuTrigger);
        if (!submenuPanel) return;

        submenuTrigger.addEventListener('click', function (event) {
          if (window.innerWidth < 990) return;
          event.preventDefault();
          openSubmenu(submenuTrigger);
        });

        submenuTrigger.addEventListener('focus', function () {
          if (desktopHover.matches) openSubmenu(submenuTrigger);
        });

        submenuTrigger.addEventListener('pointerenter', function () {
          scheduleSubmenuOpen(submenuTrigger);
        });
        submenuTrigger.addEventListener('pointerleave', scheduleSubmenuClose);
        submenuPanel.addEventListener('pointerenter', clearSubmenuTimers);
        submenuPanel.addEventListener('pointerleave', scheduleSubmenuClose);
      });

      if (megaClose) {
        megaClose.addEventListener('click', function () {
          closeMega(true);
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeMega(false);
        });
      }

      /* Un lien du panneau part vers une autre page. Sans ce qui suit, le
         méga-menu restait ouvert et parfaitement immobile pendant tout le
         chargement — 640 ms mesurés du clic au départ de page en fibre,
         plusieurs secondes en 4G — et l'animation de fermeture, qui existe
         pourtant, ne jouait jamais. On ne détourne pas le clic : on lance
         seulement la fermeture, qui s'anime par-dessus le chargement. */
      function closeOnNavigation(scope, close) {
        if (!scope) return;
        scope.addEventListener('click', function (event) {
          if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
          var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
          if (!link || !scope.contains(link)) return;
          if (link.target && link.target !== '_self') return;
          close();
        });
      }

      closeOnNavigation(mega, function () {
        closeMega(false);
      });

      submenuTriggers.forEach(function (submenuTrigger) {
        closeOnNavigation(panelForSubmenu(submenuTrigger), function () {
          closeSubmenu(false, false);
        });
      });

      closeOnNavigation(drawer, function () {
        if (drawer.open) drawer.close();
      });

      document.addEventListener('pointerdown', function (event) {
        if (root.contains(event.target)) return;
        if (isOpen) closeMega(false);
        closeSubmenu(false, false);
      });

      document.addEventListener('focusin', function (event) {
        if (root.contains(event.target)) return;
        if (isOpen) closeMega(false);
        closeSubmenu(false, false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (isOpen) {
            event.preventDefault();
            closeMega(true);
          } else if (activeSubmenuTrigger) {
            event.preventDefault();
            closeSubmenu(true, false);
          }
        }
      });

      if (drawer && drawerOpen) {
        drawerOpen.addEventListener('click', function () {
          if (isOpen) closeMega(false);
          closeSubmenu(false, true);
          drawer.showModal();
        });
      }

      if (drawer && drawerClose) {
        drawerClose.addEventListener('click', function () {
          drawer.close();
        });
      }

      if (drawer) {
        drawer.addEventListener('click', function (event) {
          if (event.target === drawer) drawer.close();
        });
      }

      window.addEventListener('resize', function () {
        if (window.innerWidth < 990 && isOpen) closeMega(false);
        if (window.innerWidth < 990) closeSubmenu(false, true);
        if (window.innerWidth >= 990 && drawer && drawer.open) drawer.close();
      });
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-mon-premium-header]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  /* Bascule de l'état défilé du header. */
  (function () {
    function initScrollState() {
      var section = document.querySelector('.mon-premium-header-section');
      if (!section || section.dataset.monScrollState === '1') return;
      section.dataset.monScrollState = '1';

      // Le thème Horizon fait défiler .page-wrapper, pas la fenêtre.
      var scroller = document.querySelector('.page-wrapper');
      var target = scroller || window;
      var hero = document.querySelector('.mon-premium-hero, .mon-hero');

      function limit() {
        var headerH = section.offsetHeight || 0;
        if (hero && hero.offsetHeight) return Math.max(64, hero.offsetHeight - headerH);
        return 64;
      }

      var ticking = false;
      function update() {
        ticking = false;
        var y = scroller ? scroller.scrollTop : window.scrollY;
        section.classList.toggle('is-scrolled', y > limit());
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      target.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollState);
    } else {
      initScrollState();
    }
    document.addEventListener('shopify:section:load', initScrollState);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-premium-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealContent(root) {
      root.classList.add('is-loaded');
    }

    function init(root) {
      if (!root) return;

      if (root.dataset.monPremiumHeroReady === 'true') {
        revealContent(root);
        return;
      }

      root.dataset.monPremiumHeroReady = 'true';

      root.querySelectorAll('[data-mon-premium-video]').forEach(function (video) {
        function revealVideo() {
          video.classList.add('is-ready');
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }

        video.addEventListener('loadeddata', revealVideo, { once: true });
        video.addEventListener('playing', revealVideo, { once: true });
        if (video.readyState >= 2) revealVideo();
      });

      window.setTimeout(function () {
        revealContent(root);
      }, 1000);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var heading = root.querySelector('.mon-premium-hero__heading');
          if (!heading) {
            revealContent(root);
            return;
          }
          heading.addEventListener(
            'animationend',
            function () {
              revealContent(root);
            },
            { once: true }
          );
        });
      });
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-mon-premium-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-mon-premium-hero]')
        : null;
      if (root) {
        root.dataset.monPremiumHeroReady = 'false';
        init(root);
      } else {
        boot(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-produit-benefices"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.mon-pben');
    if (!sections.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cibles = document.querySelectorAll('.mon-pben .mr-reveal');

    if (reduce || !('IntersectionObserver' in window)) {
      cibles.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    );

    cibles.forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-rituels-signature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mon-rituals-signature')) {
    class MonRitualsSignature extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-rituals-viewport]');
        this.track = this.querySelector('[data-rituals-track]');
        this.originals = Array.from(this.querySelectorAll('[data-ritual-card]'));
        this.previousButton = this.querySelector('[data-ritual-prev]');
        this.nextButton = this.querySelector('[data-ritual-next]');
        this.status = this.querySelector('[data-ritual-status]');
        this.labelsNode = this.querySelector('[data-rituals-labels]');
        this.labels = this.labelsNode ? JSON.parse(this.labelsNode.textContent) : { item: 'Soin', of: 'sur' };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.tabletMedia = window.matchMedia('(max-width: 1199px)');
        this.realCount = this.originals.length;
        this.sectionIsNear = false;
        this.sectionIsVisible = false;
        this.scrollTimer = null;
        this.announcedIndex = -1;

        if (!this.viewport || !this.track || this.realCount === 0) return;

        // La boucle repose sur une copie complète des soins de chaque cote :
        // on peut donc toujours avancer, et il y a toujours une carte a l'ecran.
        this.loop = this.realCount > 2;
        if (this.loop) this.buildLoop();

        this.cards = Array.from(this.querySelectorAll('[data-ritual-card]'));
        this.cards.forEach((card, index) => {
          card.dataset.index = index;
        });
        this.offset = this.loop ? this.realCount : 0;
        this.activeIndex = this.offset + this.startIndex();

        this.onScroll = this.onScroll.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.cards.forEach((card, index) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) return;
            if (index !== this.activeIndex) this.goTo(index);
          });
        });

        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.mobileMedia.addEventListener('change', this.onMediaChange);
        this.tabletMedia.addEventListener('change', this.onMediaChange);

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);

        this.nearObserver = new IntersectionObserver(
          (entries) => {
            this.sectionIsNear = entries[0].isIntersecting;
            this.syncVideo();
          },
          { rootMargin: '180px 0px' }
        );
        this.nearObserver.observe(this);

        this.visibleObserver = new IntersectionObserver(
          (entries) => {
            this.sectionIsVisible = entries[0].isIntersecting;
            this.syncVideo();
          },
          { threshold: 0.12 }
        );
        this.visibleObserver.observe(this);

        this.syncMetrics();
        this.setActive(this.activeIndex, false);
        requestAnimationFrame(() => this.centerCard(this.activeIndex, false));
      }

      disconnectedCallback() {
        if (!this.viewport) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.mobileMedia.removeEventListener('change', this.onMediaChange);
        this.tabletMedia.removeEventListener('change', this.onMediaChange);
        this.resizeObserver?.disconnect();
        this.nearObserver?.disconnect();
        this.visibleObserver?.disconnect();
        window.clearTimeout(this.scrollTimer);
        this.pauseAllVideos();
      }

      buildLoop() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        this.originals.forEach((card) => {
          before.appendChild(this.cloneCard(card));
          after.appendChild(this.cloneCard(card));
        });

        this.track.insertBefore(before, this.track.firstChild);
        this.track.appendChild(after);
      }

      cloneCard(card) {
        const clone = card.cloneNode(true);
        clone.dataset.ritualClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        return clone;
      }

      startIndex() {
        if (this.mobileMedia.matches) return 0;
        return Math.min(Number(this.dataset.initialDesktop) || 2, this.realCount - 1);
      }

      realIndex(index) {
        if (!this.loop) return Math.max(0, Math.min(index, this.cards.length - 1));
        return (((index - this.offset) % this.realCount) + this.realCount) % this.realCount;
      }

      syncMetrics() {
        const viewportWidth = this.viewport.clientWidth;
        const styles = getComputedStyle(this);
        const gap = parseFloat(styles.getPropertyValue('--mon-rituals-gap')) || 28;
        let visibleCards = 5;
        let cardWidth;

        if (this.mobileMedia.matches) {
          cardWidth = viewportWidth / 1.12;
        } else {
          if (this.tabletMedia.matches) visibleCards = 3;
          cardWidth = (viewportWidth - gap * (visibleCards - 1)) / visibleCards;
        }

        this.style.setProperty('--mon-card-width', `${Math.max(180, cardWidth)}px`);
      }

      onResize() {
        this.syncMetrics();
        requestAnimationFrame(() => this.centerCard(this.activeIndex, false));
      }

      onMediaChange() {
        const nextIndex = this.offset + this.startIndex();
        this.syncMetrics();
        this.setActive(nextIndex, false);
        requestAnimationFrame(() => this.centerCard(nextIndex, false));
      }

      onScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.settle(), 110);
      }

      // Une fois le defilement termine : on rembobine si besoin, puis on active
      // la carte visee — dans cet ordre, pour que la transition reste douce.
      settle() {
        let index = this.closestCardIndex();
        if (this.loop) index = this.recenterViewport(index);
        this.setActive(index, true);
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.activeIndex + 1);
        }
      }

      onVisibilityChange() {
        this.syncVideo();
      }

      onBlockSelect(event) {
        const card = this.originals.find((item) => item.dataset.blockId === event.detail.blockId);
        if (!card) return;
        const index = this.cards.indexOf(card);
        if (index < 0) return;
        this.setActive(index, true);
        this.centerCard(index, true);
      }

      closestCardIndex() {
        const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      goTo(index) {
        let target = index;

        if (this.loop) {
          // Filet de securite : si la cible approche du bout des copies (clics
          // enchaines sans pause), on rembobine avant de repartir.
          if (target < 1 || target > this.cards.length - 2) {
            const distance = index - this.activeIndex;
            target = this.recenterViewport(this.activeIndex) + distance;
          }
        }

        target = Math.max(0, Math.min(target, this.cards.length - 1));
        this.setActive(target, true);
        this.centerCard(target, true);
      }

      // Rembobine sur la copie centrale : le decalage vaut exactement une serie
      // complete, donc rien ne bouge a l'ecran. L'etat visuel (carte agrandie)
      // est reporte tel quel sur les cartes decalees, transitions coupees, pour
      // que le saut soit strictement invisible.
      recenterViewport(index) {
        const centeredIndex = this.offset + this.realIndex(index);
        if (centeredIndex === index) return index;

        const currentCard = this.cards[index];
        const centeredCard = this.cards[centeredIndex];
        if (!currentCard || !centeredCard) return index;

        const shift = index - centeredIndex;
        const delta = centeredCard.offsetLeft - currentCard.offsetLeft;
        const previousBehavior = this.viewport.style.scrollBehavior;

        this.classList.add('is-recentering');
        this.viewport.style.scrollBehavior = 'auto';
        this.activeIndex = Math.max(0, Math.min(this.activeIndex - shift, this.cards.length - 1));
        this.updateCards();
        this.viewport.scrollLeft += delta;
        this.viewport.style.scrollBehavior = previousBehavior;
        void this.offsetHeight;
        this.classList.remove('is-recentering');

        return centeredIndex;
      }

      centerCard(index, animate) {
        const card = this.cards[index];
        if (!card) return;
        let left = card.offsetLeft + card.offsetWidth / 2 - this.viewport.clientWidth / 2;
        if (this.mobileMedia.matches) left = card.offsetLeft;
        this.viewport.scrollTo({
          left,
          behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant'
        });
      }

      updateCards() {
        this.cards.forEach((card, cardIndex) => {
          const distance = Math.abs(cardIndex - this.activeIndex);
          card.classList.toggle('is-active', distance === 0);
          card.classList.toggle('is-near', distance === 1);
          card.setAttribute('aria-current', distance === 0 ? 'true' : 'false');
        });
      }

      setActive(index, announce) {
        this.activeIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        this.updateCards();

        if (this.previousButton) this.previousButton.disabled = !this.loop && this.activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = !this.loop && this.activeIndex === this.cards.length - 1;

        const currentReal = this.realIndex(this.activeIndex);
        if (announce && this.status && currentReal !== this.announcedIndex) {
          this.announcedIndex = currentReal;
          this.status.textContent = `${this.labels.item} ${currentReal + 1} ${this.labels.of} ${this.realCount}`;
        }

        this.syncVideo();
      }

      syncVideo() {
        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          if (!video) return;

          const canPlay =
            index === this.activeIndex &&
            this.sectionIsNear &&
            this.sectionIsVisible &&
            !document.hidden &&
            !this.reducedMotion.matches;

          if (index === this.activeIndex && this.sectionIsNear) video.preload = 'metadata';

          if (canPlay) {
            const playPromise = video.play();
            if (playPromise) {
              playPromise
                .then(() => card.classList.add('is-video-visible'))
                .catch(() => card.classList.remove('is-video-visible'));
            }
          } else {
            video.pause();
            card.classList.remove('is-video-visible');
            if (index !== this.activeIndex) {
              video.currentTime = 0;
              video.preload = 'none';
            }
          }
        });
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
      }
    }

    customElements.define('mon-rituals-signature', MonRitualsSignature);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mon-rituels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ritReady === '1') return;
      root.dataset.ritReady = '1';

      var refine   = root.querySelector('[data-rit-refine]');
      var panel    = root.querySelector('[data-rit-filters]');
      var badge    = root.querySelector('[data-rit-count]');
      var clearBtn = root.querySelector('[data-rit-clear]');
      var gridWrap = root.querySelector('[data-rit-grid]');
      var shownEl  = root.querySelector('[data-rit-shown]');
      var noneEl   = root.querySelector('[data-rit-none]');
      var editorial = Array.prototype.slice.call(root.querySelectorAll('[data-rit-editorial]'));
      var boxes    = Array.prototype.slice.call(root.querySelectorAll('.mon-rit__box'));
      var cards    = Array.prototype.slice.call(root.querySelectorAll('.mon-rit__gcard'));

      function groups() {
        var g = {};
        boxes.forEach(function (b) {
          if (!b.checked) return;
          (g[b.dataset.group] = g[b.dataset.group] || []).push(b.value);
        });
        return g;
      }

      function apply() {
        var sel = groups();
        var keys = Object.keys(sel);
        var active = keys.length > 0;

        // Les deux logiques ne cohabitent jamais : éditorial OU grille.
        editorial.forEach(function (el) { el.hidden = active; });
        if (gridWrap) gridWrap.hidden = !active;
        if (clearBtn) clearBtn.hidden = !active;

        var n = boxes.filter(function (b) { return b.checked; }).length;
        if (badge) { badge.hidden = n === 0; badge.textContent = String(n); }

        if (!active) return;

        var shown = 0;
        cards.forEach(function (card) {
          var tags = card.dataset.tags || '';
          var ok = keys.every(function (k) {
            return sel[k].some(function (v) { return tags.indexOf('~' + v + '~') > -1; });
          });
          card.hidden = !ok;
          if (ok) shown += 1;
        });
        if (shownEl) shownEl.textContent = String(shown);
        if (noneEl) noneEl.hidden = shown !== 0;
      }

      if (refine && panel) {
        refine.addEventListener('click', function () {
          var open = panel.hidden;
          panel.hidden = !open;
          refine.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      boxes.forEach(function (b) { b.addEventListener('change', apply); });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          boxes.forEach(function (b) { b.checked = false; });
          apply();
          if (panel) { panel.hidden = true; }
          if (refine) refine.setAttribute('aria-expanded', 'false');
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      apply();
    }

    function boot() { document.querySelectorAll('[data-mon-rit]').forEach(init); }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function HeroCarousel(root) {
      this.root = root;
      this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-mr-slide]'));
      this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-mr-dot]'));
      this.pauseBtn = root.querySelector('[data-mr-pause]');
      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.visible = true;

      this.interval = parseInt(root.dataset.interval, 10) || 5500;
      this.autoplay = root.dataset.autoplay === 'true';
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.bind();
      this.playVideo(this.slides[0]);

      if (this.canRun()) this.start();
    }

    HeroCarousel.prototype.canRun = function () {
      return this.autoplay && this.slides.length > 1 && !this.reduced && !this.paused && this.visible;
    };

    HeroCarousel.prototype.bind = function () {
      var self = this;

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.goTo(parseInt(dot.dataset.index, 10));
          self.restart();
        });
      });

      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', function () {
          if (self.paused) {
            self.resume();
          } else {
            self.pause();
          }
        });
      }

      // Pas de défilement quand l'onglet est en arrière-plan
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          self.stop();
        } else {
          self.start();
        }
      });

      // Pas de défilement quand le hero est hors écran
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              self.visible = entry.isIntersecting;
              if (entry.isIntersecting) {
                self.start();
              } else {
                self.stop();
              }
            });
          },
          { threshold: 0.15 }
        );
        io.observe(this.root);
      }

      // Pause au survol et au focus : laisse le temps de lire
      this.root.addEventListener('mouseenter', function () {
        self.stop();
      });
      this.root.addEventListener('mouseleave', function () {
        self.start();
      });
      this.root.addEventListener('focusin', function () {
        self.stop();
      });

      this.root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          self.goTo(self.index + 1);
          self.restart();
        } else if (event.key === 'ArrowLeft') {
          self.goTo(self.index - 1);
          self.restart();
        }
      });
    };

    HeroCarousel.prototype.goTo = function (next) {
      var total = this.slides.length;
      if (total < 2) return;

      var target = ((next % total) + total) % total;
      if (target === this.index) return;

      var outgoing = this.slides[this.index];
      var incoming = this.slides[target];

      outgoing.classList.remove('is-active');
      outgoing.setAttribute('aria-hidden', 'true');
      this.setFocusable(outgoing, false);
      this.stopVideo(outgoing);

      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      this.setFocusable(incoming, true);
      this.playVideo(incoming);

      if (this.dots.length) {
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].removeAttribute('aria-current');
        this.dots[target].classList.add('is-active');
        this.dots[target].setAttribute('aria-current', 'true');
      }

      this.index = target;
    };

    HeroCarousel.prototype.setFocusable = function (slide, focusable) {
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (focusable) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', '-1');
        }
      });
    };

    HeroCarousel.prototype.playVideo = function (slide) {
      if (!slide || this.reduced) return;
      var video = slide.querySelector('[data-mr-hero-video]');
      if (!video) return;

      var reveal = function () {
        slide.classList.add('is-video-ready');
      };
      video.addEventListener('loadeddata', reveal, { once: true });
      video.addEventListener('playing', reveal, { once: true });
      if (video.readyState >= 2) reveal();

      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
    };

    HeroCarousel.prototype.stopVideo = function (slide) {
      if (!slide) return;
      var video = slide.querySelector('[data-mr-hero-video]');
      if (video) video.pause();
    };

    HeroCarousel.prototype.start = function () {
      var self = this;
      if (this.timer || !this.canRun()) return;
      this.timer = window.setInterval(function () {
        self.goTo(self.index + 1);
      }, this.interval);
    };

    HeroCarousel.prototype.stop = function () {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    };

    HeroCarousel.prototype.restart = function () {
      this.stop();
      this.start();
    };

    HeroCarousel.prototype.pause = function () {
      this.paused = true;
      this.stop();
      this.root.classList.add('is-paused');
      if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', 'Reprendre le carrousel');
    };

    HeroCarousel.prototype.resume = function () {
      this.paused = false;
      this.root.classList.remove('is-paused');
      if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', 'Mettre le carrousel en pause');
      this.start();
    };

    function init(root) {
      if (!root || root.dataset.mrHeroReady === 'true') return;
      root.dataset.mrHeroReady = 'true';
      new HeroCarousel(root);
    }

    function boot() {
      document.querySelectorAll('[data-mr-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-mr-hero]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
